module.exports = __webpack_public_path__ + "media/images/icons/outlined/fall-94c22275f3c5101b30409aa645d2bdf7.svg";